import React, { useState } from 'react';
import { Card, Grid, TextField, Box, Stepper, Step, StepLabel, StepIconProps, StepIcon, Typography, FormControl, InputLabel, MenuItem } from '@mui/material';
import KenButton from '../../../GlobalComponents/KenButton';
import { useStyles } from '../styles';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { AppButton } from '../../../Components/AppButton';
import KenColors from '../../../Helpers/Themes/kenColors';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import AddIcon from '@mui/icons-material/Add';
import Switch from '@mui/material/Switch';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Utils/routes';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

const steps = ['Personal', 'Education Qualification', 'Work Experience', 'Interests', 'References'];
const field = [
  {
    name: 'Wanted Job Title',
    type: 'text',
  },
  {
    name: 'First Name',
    type: 'text',
  },
  {
    name: 'Last Name',
    type: 'text',
  },
  {
    name: 'Choose Dates',
    type: 'date',
  },
  {
    name: 'Place of Birth',
    type: 'text',
  },
  {
    name: 'Phone',
    type: 'text',
  },
  {
    name: 'Country',
    type: 'text',
  },
  {
    name: 'City',
    type: 'text',
  },
  {
    name: 'Nationality',
    type: 'text',
  },
  {
    name: 'Postal Code',
    type: 'text',
  },
  {
    name: 'Email',
    type: 'text',
  },
  {
    name: 'Address',
    type: 'text',
  },
  {
    name: 'Driving Licence',
    type: 'text',
  },
];

const CreateResume = (props: any) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [value, setValue] = useState('');
  const [age, setAge] = React.useState('');
  const [valueEditor, setValueEditor] = useState('');

  const handleChangeEditor = (content: string) => {
    setValueEditor(content);
  };

  const modules = {
    toolbar: {
      container: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{ list: 'ordered' }, { list: 'bullet' }], ['link', 'image'], ['clean']],
    },
  };

  const handleChanges = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };
  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const CustomStepIcon = (props: StepIconProps) => {
    const { active, completed, className } = props;

    return completed ? <CheckCircleIcon style={{ color: 'green' }} /> : <StepIcon {...props} />;
  };
  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Card sx={{ borderRadius: 3, p: 4, mt: 1, boxShadow: 'none !important' }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: { optional?: React.ReactNode } = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }

              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps} StepIconComponent={CustomStepIcon}>
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Card>
        {activeStep == 1 && (
          <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
            <Box>
              <Grid container>
                <Grid item xs={6}>
                  <Typography className={classes.StepperTitle}>Resume Objective</Typography>
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                  <AppButton
                    size="small"
                    variant="contained"
                    className={classes.postJobBtns1}
                    others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                    background={'#E8EBF3'}
                  >
                    Save
                  </AppButton>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100px' }}>
                    <ReactQuill value={valueEditor} onChange={handleChangeEditor} modules={modules} placeholder="Description" style={{ flex: 1, overflow: 'auto' }} />
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Card>
        )}
        {activeStep == 3 && (
          <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
            <Box>
              <Grid container>
                <Grid item xs={6}>
                  <Typography className={classes.StepperTitle}>Skills</Typography>
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                  <AppButton size="small" variant="contained" className={classes.postJobBtns1} others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }} background={'white'}>
                    Delete
                  </AppButton>
                  <AppButton
                    size="small"
                    variant="contained"
                    className={classes.postJobBtns1}
                    others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                    background={'#E8EBF3'}
                  >
                    Save
                  </AppButton>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={4}>
                  <TextField id="outlined-basic" label="Skill" variant="outlined" fullWidth />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="outlined-basic" label="Level" variant="outlined" fullWidth />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'start' }}>
                  <KenButton
                    variant="text"
                    sx={{
                      mt: 1,
                      borderRadius: '8px',
                      fontweight: 500,
                      backgroundColor: 'none',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      color: 'black',
                      width: 200,
                    }}
                    fullWidth
                  >
                    <AddIcon /> Add more skill
                  </KenButton>
                </Grid>
              </Grid>
            </Box>
          </Card>
        )}
        {activeStep == 4 && (
          <Card sx={{ borderRadius: 3, p: 5, mt: 1 }}>
            <Box>
              <Grid container>
                <Grid item xs={6}>
                  <Typography className={classes.StepperTitle}>References</Typography>
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                  <AppButton size="small" variant="contained" className={classes.postJobBtns1} others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }} background={'white'}>
                    Delete
                  </AppButton>
                  <AppButton
                    size="small"
                    variant="contained"
                    className={classes.postJobBtns1}
                    others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                    background={'#E8EBF3'}
                  >
                    Save
                  </AppButton>
                </Grid>
              </Grid>
              <Box sx={{ mt: 1, backgroundColor: '#EAEFFF', display: 'flex', justifyContent: 'start', p: 2, width: 700, borderRadius: 2 }}>
                <Switch {...label} defaultChecked />
                <Typography sx={{ mt: 1, fontWeight: 500 }}>References on request? Displays "References available on request" on your resume</Typography>
              </Box>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={4}>
                  <TextField id="outlined-basic" label="Company Name" variant="outlined" fullWidth />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="outlined-basic" label="Contact Person" variant="outlined" fullWidth />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="outlined-basic" label="Phone Number" variant="outlined" fullWidth />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="outlined-basic" label="Email" variant="outlined" fullWidth />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'start' }}>
                  <KenButton
                    variant="text"
                    sx={{
                      mt: 1,
                      borderRadius: '8px',
                      fontweight: 500,
                      backgroundColor: 'none',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      color: 'black',
                      width: 200,
                    }}
                    fullWidth
                  >
                    <AddIcon /> Add more reference
                  </KenButton>
                </Grid>
              </Grid>
            </Box>
          </Card>
        )}
        {activeStep === steps.length && (
          <Box sx={{ height: '59vh', mt: 2 }} className="scrollbar-cusgray">
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
                  <Typography className={classes.StepperTitle}>Auckland</Typography>
                  <Grid container sx={{ mt: 1, border: '1px solid #EDEEF1', height: 300, width: '100%' }}>
                    <Grid item xs={4} sx={{ backgroundColor: '#EDEEF1' }}></Grid>
                    <Grid item xs={8} sx={{ backgroundColor: 'white' }}></Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
                  <Typography className={classes.StepperTitle}>Edinburgh</Typography>
                  <Grid container sx={{ mt: 1, border: '1px solid #EDEEF1', height: 300, width: '100%' }}>
                    <Grid item xs={4} sx={{ backgroundColor: '#EDEEF1' }}></Grid>
                    <Grid item xs={8} sx={{ backgroundColor: 'white' }}></Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
                  <Typography className={classes.StepperTitle}>Princeton</Typography>
                  <Grid container sx={{ mt: 1, border: '1px solid #EDEEF1', height: 300, width: '100%' }}>
                    <Grid item xs={4} sx={{ backgroundColor: '#EDEEF1' }}></Grid>
                    <Grid item xs={8} sx={{ backgroundColor: 'white' }}></Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
                  <Typography className={classes.StepperTitle}>Auckland</Typography>
                  <Grid container sx={{ mt: 1, border: '1px solid #EDEEF1', height: 300, width: '100%' }}>
                    <Grid item xs={4} sx={{ backgroundColor: '#EDEEF1' }}></Grid>
                    <Grid item xs={8} sx={{ backgroundColor: 'white' }}></Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card sx={{ borderRadius: 3, p: 5, mt: 1, boxShadow: 'none !important' }}>
                  <Typography className={classes.StepperTitle}>Princeton</Typography>
                  <Grid container sx={{ mt: 1, border: '1px solid #EDEEF1', height: 300, width: '100%' }}>
                    <Grid item xs={4} sx={{ backgroundColor: '#3061FF' }}></Grid>
                    <Grid item xs={8} sx={{ backgroundColor: 'white' }}></Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Box>
        )}
        {activeStep === steps.length ? (
          <React.Fragment>
            <Card sx={{ borderRadius: 3, p: 3, mt: 3, boxShadow: 'none !important' }}>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'start' }}>
                  <KenButton
                    variant="text"
                    sx={{
                      borderRadius: '8px',
                      fontweight: 500,
                      backgroundColor: 'none',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      color: 'black',
                      width: 150,
                    }}
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    fullWidth
                  >
                    previous step
                  </KenButton>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <KenButton
                      variant="text"
                      sx={{
                        borderRadius: '8px',
                        fontweight: 500,
                        backgroundColor: 'none',
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        color: 'black',
                        width: 150,
                      }}
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      fullWidth
                    >
                      Save resume
                    </KenButton>
                    <KenButton
                      variant="contained"
                      style={{ width: 230, borderRadius: '7px' }}
                      fullWidth
                      onClick={() => {
                        navigate(routes.resumeLibrary);
                      }}
                    >
                      <FileDownloadOutlined /> Save & Download Resume
                    </KenButton>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {activeStep == 0 && (
              <Card sx={{ borderRadius: 3, p: 3, mt: 2, boxShadow: 'none !important' }}>
                <Box sx={{ height: '54.5vh' }}>
                  <Typography className={classes.StepperTitle}>Personal</Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'start', mt: 2 }}>
                    <AppButton size="small" variant="contained" className={classes.postJobBtns1} others={{ color: KenColors.kenBlack, width: 10, height: 60 }} background={'#F6F8FB'}>
                      <PersonRoundedIcon />
                    </AppButton>
                    <Typography sx={{ ml: 2, mt: 2, fontWeight: 500 }}>Upload photo</Typography>
                  </Box>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    {field.map((val) => {
                      return (
                        <Grid item xs={4}>
                          {val.name == 'Choose Dates' ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                                <DatePicker label="Choose Dates" sx={{ width: '100%' }} />
                              </DemoContainer>
                            </LocalizationProvider>
                          ) : (
                            <TextField
                              label={val.name}
                              placeholder={val.name}
                              type={val.type}
                              name={val.name}
                              onChange={handleChange}
                              fullWidth
                              variant="outlined"
                              inputProps={{
                                placeholder: '',
                              }}
                            />
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
                <hr style={{ border: '1px solid #E5E6EA', marginTop: 35 }} />
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                  <KenButton
                    variant="text"
                    sx={{
                      mt: 2,
                      borderRadius: '8px',
                      fontweight: 500,
                      backgroundColor: 'none',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      color: 'black',
                      width: 100,
                    }}
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    fullWidth
                  >
                    Back
                  </KenButton>
                  <KenButton variant="contained" style={{ width: 100, marginTop: 15, borderRadius: '7px' }} fullWidth onClick={handleNext}>
                    Next
                  </KenButton>
                </Box>
              </Card>
            )}
            {activeStep == 1 && (
              <Card sx={{ borderRadius: 3, p: 3, mt: 2, boxShadow: 'none !important' }}>
                <Box>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography className={classes.StepperTitle}>Education and Qualification</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                      <AppButton
                        size="small"
                        variant="contained"
                        className={classes.postJobBtns1}
                        others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                        background={'white'}
                      >
                        Delete
                      </AppButton>
                      <AppButton
                        size="small"
                        variant="contained"
                        className={classes.postJobBtns1}
                        others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                        background={'#E8EBF3'}
                      >
                        Save
                      </AppButton>
                    </Grid>
                  </Grid>
                  <Box sx={{ height: '25.5vh' }} className="scrollbar-cusgray">
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={4}>
                        <TextField id="outlined-basic" label="Degree" variant="outlined" fullWidth />
                      </Grid>
                      <Grid item xs={4}>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">City</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={age}
                              label="City"
                              onChange={handleChanges}
                              sx={{
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#3061FF',
                                },
                              }}
                            >
                              <MenuItem
                                value={10}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Chennai
                              </MenuItem>
                              <MenuItem
                                value={20}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Coimbatore
                              </MenuItem>
                              <MenuItem
                                value={30}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Bangalore
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <TextField id="outlined-basic" label="School" variant="outlined" fullWidth />
                      </Grid>
                      <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                            <DatePicker label="Start Date" sx={{ width: '100%' }} />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker']}>
                            <DatePicker label="End Date" sx={{ width: '100%' }} />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12}>
                        <div style={{ display: 'flex', flexDirection: 'column', height: '200px' }}>
                          <ReactQuill value={valueEditor} onChange={handleChangeEditor} modules={modules} placeholder="Description" style={{ flex: 1, overflow: 'auto' }} />
                        </div>
                      </Grid>
                      <KenButton
                        variant="text"
                        sx={{
                          mt: 2,
                          borderRadius: '8px',
                          fontweight: 500,
                          backgroundColor: 'none',
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                          color: 'black',
                          width: 200,
                        }}
                        fullWidth
                      >
                        <AddIcon /> Add more education
                      </KenButton>
                    </Grid>
                  </Box>
                </Box>
                <hr style={{ border: '1px solid #E5E6EA', marginTop: 20 }} />
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                  <KenButton
                    variant="text"
                    sx={{
                      mt: 2,
                      borderRadius: '8px',
                      fontweight: 500,
                      backgroundColor: 'none',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      color: 'black',
                      width: 100,
                    }}
                    // disabled={activeStep == 0}
                    onClick={handleBack}
                    fullWidth
                  >
                    Back
                  </KenButton>
                  <KenButton variant="contained" style={{ width: 100, marginTop: 15, borderRadius: '7px' }} fullWidth onClick={handleNext}>
                    Next
                  </KenButton>
                </Box>
              </Card>
            )}
            {activeStep == 2 && (
              <Box sx={{ p: 3 }}>
                <Card sx={{ borderRadius: 3, mt: 2, boxShadow: 'none !important' }}>
                  <Box>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography className={classes.StepperTitle}>Work Experience</Typography>
                      </Grid>
                      <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                        <AppButton
                          size="small"
                          variant="contained"
                          className={classes.postJobBtns1}
                          others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                          background={'white'}
                        >
                          Delete
                        </AppButton>
                        <AppButton
                          size="small"
                          variant="contained"
                          className={classes.postJobBtns1}
                          others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                          background={'#E8EBF3'}
                        >
                          Save
                        </AppButton>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={4}>
                        <TextField id="outlined-basic" label="Job Title" variant="outlined" fullWidth />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField id="outlined-basic" label="Employer" variant="outlined" fullWidth />
                      </Grid>
                      <Grid item xs={4}>
                        <Box sx={{ width: '!00%' }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">City</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={age}
                              label="City"
                              onChange={handleChanges}
                              sx={{
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#3061FF',
                                },
                              }}
                            >
                              <MenuItem
                                value={10}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Chennai
                              </MenuItem>
                              <MenuItem
                                value={20}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Coimbatore
                              </MenuItem>
                              <MenuItem
                                value={30}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Bangalore
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>

                      <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                            <DatePicker label="Start Date" sx={{ width: '100%' }} />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker']}>
                            <DatePicker label="End Date" sx={{ width: '100%' }} />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'start' }}>
                        <KenButton
                          variant="text"
                          sx={{
                            mt: 2,
                            borderRadius: '8px',
                            fontweight: 500,
                            backgroundColor: 'none',
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            color: 'black',
                            width: 200,
                          }}
                          fullWidth
                        >
                          <AddIcon /> Add more education
                        </KenButton>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
                <Box sx={{ mt: 33 }}>
                  <hr style={{ border: '1px solid #E5E6EA', marginTop: 20 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <KenButton
                      variant="text"
                      sx={{
                        mt: 2,
                        borderRadius: '8px',
                        fontweight: 500,
                        backgroundColor: 'none',
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        color: 'black',
                        width: 100,
                      }}
                      // disabled={activeStep === 0}
                      onClick={handleBack}
                      fullWidth
                    >
                      Back
                    </KenButton>
                    <KenButton variant="contained" style={{ width: 100, marginTop: 15, borderRadius: '7px' }} fullWidth onClick={handleNext}>
                      Next
                    </KenButton>
                  </Box>
                </Box>
              </Box>
            )}
            {activeStep == 3 && (
              <Box sx={{ p: 3 }}>
                <Card sx={{ borderRadius: 3, mt: 2, boxShadow: 'none !important' }}>
                  <Box>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography className={classes.StepperTitle}>Interests</Typography>
                      </Grid>
                      <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                        <AppButton
                          size="small"
                          variant="contained"
                          className={classes.postJobBtns1}
                          others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                          background={'white'}
                        >
                          Delete
                        </AppButton>
                        <AppButton
                          size="small"
                          variant="contained"
                          className={classes.postJobBtns1}
                          others={{ color: '#373A45', width: 60, fontSize: 15, marginLeft: 10, height: 35 }}
                          background={'#E8EBF3'}
                        >
                          Save
                        </AppButton>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={4}>
                        <TextField id="outlined-basic" label="Hobby" variant="outlined" fullWidth />
                      </Grid>
                      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'start' }}>
                        <KenButton
                          variant="text"
                          sx={{
                            mt: 2,
                            borderRadius: '8px',
                            fontweight: 500,
                            backgroundColor: 'none',
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            color: 'black',
                            width: 200,
                          }}
                          fullWidth
                        >
                          <AddIcon /> Add more interest
                        </KenButton>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
                <Box sx={{ mt: 11 }}>
                  <hr style={{ border: '1px solid #E5E6EA', marginTop: 20 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <KenButton
                      variant="text"
                      sx={{
                        mt: 2,
                        borderRadius: '8px',
                        fontweight: 500,
                        backgroundColor: 'none',
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        color: 'black',
                        width: 100,
                      }}
                      // disabled={activeStep === 0}
                      onClick={handleBack}
                      fullWidth
                    >
                      Back
                    </KenButton>
                    <KenButton variant="contained" style={{ width: 100, marginTop: 15, borderRadius: '7px' }} fullWidth onClick={handleNext}>
                      Next
                    </KenButton>
                  </Box>
                </Box>
              </Box>
            )}
            {activeStep == 4 && (
              <Box sx={{ p: 3 }}>
                <Card sx={{ borderRadius: 3, mt: 1, boxShadow: 'none !important' }}>
                  <Box>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12}>
                        <Box sx={{ width: '100%' }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Add extra section</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={age}
                              label="Add extra section"
                              onChange={handleChanges}
                              sx={{
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#3061FF',
                                },
                              }}
                            >
                              <MenuItem
                                value={10}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Languages
                              </MenuItem>
                              <MenuItem
                                value={20}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Curses
                              </MenuItem>
                              <MenuItem
                                value={30}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Achievements
                              </MenuItem>
                              <MenuItem
                                value={20}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Publications
                              </MenuItem>
                              <MenuItem
                                value={30}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Create custom section
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
                <Box sx={{ mt: 6.5 }}>
                  <hr style={{ border: '1px solid #E5E6EA', marginTop: 20 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <KenButton
                      variant="text"
                      sx={{
                        mt: 2,
                        borderRadius: '8px',
                        fontweight: 500,
                        backgroundColor: 'none',
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        color: 'black',
                        width: 100,
                      }}
                      // disabled={activeStep === 0}
                      onClick={handleBack}
                      fullWidth
                    >
                      Back
                    </KenButton>
                    <KenButton variant="contained" style={{ width: 100, marginTop: 15, borderRadius: '7px' }} fullWidth onClick={handleNext}>
                      Next
                    </KenButton>
                  </Box>
                </Box>
              </Box>
            )}
          </React.Fragment>
        )}
      </Box>
    </div>
  );
};

export default CreateResume;
